export enum RegionEnum {
    Norte = 1,
    Nordeste = 2,
    CentroOeste = 3,
    Sudeste = 4,
    Sul = 5
}